export { default } from './tenant-logo';
// export default get({
//   options: ({ apiBaseUri, outletId }) => ({
//     url: `${apiBaseUri}/config/outlets/${outletId}/configs/tenant-brand`,
//     headers: constant.config.headers,
//   }),
//   name: 'config',
// })(TenantLogo);
